
export const hasLowerCase = (str: string, minChars: number = 1):boolean =>
  new RegExp(`(.*[a-z]){${minChars}}`,"g").test(str);

export const hasUpperCase = (str: string, minChars: number = 1):boolean =>
  new RegExp(`(.*[A-Z]){${minChars}}`,"g").test(str);

export const hasNumber = (str: string, minChars: number = 1):boolean =>
  new RegExp(`(.*[0-9]){${minChars}}`,"g").test(str);

export const hasSpChar = (str: string, charString: string, minChars: number = 1):boolean => {
  const regex = new RegExp("[^A-Za-z0-9]", "g"); //all Special chars
  const escapedCharString = charString.replace(regex,"\\$&") //precede each special char with backslash
  const regex2 = new RegExp(`(.*[${escapedCharString}]){${minChars}}`,"g") //match passed charString a minimum amount of times
  return regex2.test(str);
}

export const hasNotAllowedSpChar = (str: string, allowedCharString: string, minChars: number = 1):boolean => {
  const regex = new RegExp("[^A-Za-z0-9]", "g"); //all Special chars
  const escapedCharString = allowedCharString.replace(regex,"\\$&") //precede each special char with backslash
  const regex3 = new RegExp(`(.*[^A-Za-z0-9${escapedCharString}]){${minChars}}`,"g") //match any other special char not provided by charString a minimum amount of times
  return regex3.test(str);
}

export const hasConsecutiveChar = (str: string, count: number) => {
  const regex = new RegExp("(.)\\1{" + (count-1) + "}");
  return regex.test(str)
}

export const hasSeqChar = (str: string, count: number) => {
  const regex = new RegExp(".*((a(?=b))|(?:b(?=c))|(?:c(?=d))|(?:d(?=e))|(?:e(?=f))|(?:f(?=g))|(?:g(?=h))|(?:h(?=i))|(?:i(?=j))|(?:j(?=k))|(?:k(?=l))|(?:l(?=m))|(?:m(?=n))|(?:n(?=o))|(?:o(?=p))|(?:p(?=q))|(?:q(?=r))|(?:r(?=s))|(?:s(?=t))|(?:t(?=u))|(?:u(?=v))|(?:v(?=w))|(?:w(?=x))|(?:x(?=y))|(?:y(?=z))|(?:0(?=1))|(?:1(?=2))|(?:2(?=3))|(?:3(?=4))|(?:4(?=5))|(?:5(?=6))|(?:6(?=7))|(?:7(?=8))|(?:8(?=9))){" + (count-1) + ",}.*");
  return regex.test(str.toLowerCase());
}


